import React from "react";
import ConcertoMessa from "../imgs/concerto-messa.jpg";

import Programma from "../imgs/programma 3-2-2024.pdf";
import Locandina9 from "../imgs/concerto9novembre.jpg";
import Locandina30 from "../imgs/concerto30novembre.jpg";

const Concerti = () => {
  return (
    <div className="flex flex-col items-center z-10">
      <p className="text-red-600 font-extrabold xs:text-2x1 md:text-3xl">
        CONCERTI
      </p>
      <div className="xs:text-base md:text-xl">
        <ul>
          {/* <p>1. 9 Novembre 2024 presso il Teatro Stella di Via Pezzotti</p>
          <p>
            2. 30 Novembre 2024 presso l'ex convento dell'Annunciata di
            Abbiategrasso
          </p> */}
          <li>○ 9 Novembre 2024 - Teatro Stella di Via Pezzotti</li>
          <li>
            ○ 30 Novembre 2024 - ex convento dell'Annunciata di Abbiategrasso
          </li>
          {/* <li>
            ○ 3 febbario 2024 -{" "}
            <a href={Locandina} className="text-red-600 underline">
              Chiesa S.Luigi Gonzaga
            </a>{" "}
            :{" "}
            <a href={Programma} className="text-red-600 underline">
              programma Milano
            </a>
          </li>
          <li>
            ○ 6 giugno 2024 - Chiesa san Antonio - Messa in Sim di J.S.Bach
          </li> */}
        </ul>
      </div>
      <br />
      <br />
      <div className="flex justify-center w-3/5">
        <img src={Locandina9} className="w-2/5" />
        <img src={Locandina30} className="w-2/5" />
      </div>
    </div>
  );
};

export default Concerti;
